const { convertPugToSanitizedHtml } = require('./lib/pug-parser');

const parseCustomHtmlComponent = (md) => {
  // TODO: ./markdown-it-a-nofollow.js markdown-it-a-target-blank.js と同様の処理を行う
  // TODO: ./markdown-it-img-to-picture.js と同様の処理を行う
  md.core.ruler.push('custom_html_component', (state) => {
    state.tokens.forEach((token, idx) => {
      // NOTE: ```custom-html-component で囲まれたコードブロックを処理する
      if (token.type !== 'fence' || token.tag !== 'code' || token.info !== 'custom-html-component') {
        return;
      }

      const sanitizedHtml = convertPugToSanitizedHtml(token.content);

      const newToken = new state.Token('html_inline', '', 0);
      newToken.content = sanitizedHtml;
      state.tokens[idx] = newToken;
    });
  });
};

module.exports = parseCustomHtmlComponent;
